/**
 * A global namespace for `mousewheel` event.
 */
const mousewheelEvent = 'mousewheel';
export default mousewheelEvent;
